import React, { useState, useEffect } from "react";
import Item from "./Item";
import Filter from "./Filter";
import axios from "axios";
import routes from "../../../app/routes";
import Loader from "../../ui/Loader";

export default function Index({ coach_name, coach_id, rating, round_rating }) {
  let [programs, setPrograms] = useState([]);
  let [filteredPrograms, setFilteredPrograms] = useState([]);
  let [loader, setLoader] = useState(true);

  const loadPrograms = () => {
    setLoader(true);
    axios
      .get(routes.api.ratings.list, { params: { coach_id } })
      .then((resp) => {
        const data = resp.data;
        setPrograms(data.data);
        setFilteredPrograms(data.data);
        setLoader(false);
      });
  };

  const matchText = function (item, keyword) {
    if (keyword.length == 0) {
      return true;
    }

    return (
      item.attributes.member_first_name
        .toLowerCase()
        .includes(keyword.toLowerCase()) ||
      item.attributes.member_last_name
        .toLowerCase()
        .includes(keyword.toLowerCase())
    );
  };

  const filterPrograms = (keyword) => {
    const filteredItems = programs.filter((item) => {
      return matchText(item, keyword);
    });
    setFilteredPrograms(filteredItems);
  };

  useEffect(() => {
    loadPrograms();
  }, []);

  return (
    <>
      <Loader state={loader} />
      {!loader && programs.length == 0 && (
        <div className="content">
          <p className="empty-block-center-text font-14 text-center">
            There is no feedback available yet.
          </p>
        </div>
      )}
      {!loader && programs.length > 0 && (
        <>
          <Filter
            coach_name={coach_name}
            rating={rating}
            round_rating={round_rating}
            filterPrograms={filterPrograms}
          />
          <div className="row programs-list row-eq-height">
            {filteredPrograms.map((value, index) => {
              return (
                <div key={index} className="col-md-6 mb20">
                  <Item {...value.attributes} />
                </div>
              );
            })}
          </div>
        </>
      )}
    </>
  );
}
